import RestApiModel from "@/api/Model/RestApiModel";

class Renewal extends RestApiModel {
  static getResourceEndpoint() {
    return '/Renewal';
  }
}

export default Renewal;
